/**
 * Shared LiveKit Room.connect options — better defaults for mobile Safari / iPad.
 * @type {import('livekit-client').RoomOptions}
 */
export const LIVEKIT_ROOM_OPTIONS = {
  adaptiveStream: true,
  dynacast: true,
  audioCaptureDefaults: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
  },
  videoCaptureDefaults: {
    facingMode: "user",
  },
};
